<template>
    <div class="m:mb-5 sm:mb-1" data-cy="container_serial_timer">
        <div class="text-center text-14 text-a-gray-666666  mt-1" data-cy="text_serial_redeem_on_label">{{lbl.serial.date_redeem}} <span data-cy="text_serial_redeem_on_date">{{FilterDateTimeFullFormat(serialModel.redeemTimestamp)}}</span></div>
        <div v-if="!isStaff">
            <div v-if="showTimer" class="text-center">
                <div v-if="!isTimeExpired">
                    <div class="text-14 text-a-gray-666666" data-cy="text_serial_use_code_within">{{lbl.serial.expire_in}} <span class="text-a-red-ff4d4d" data-cy="text_serial_timer_primary">{{displayTime}}</span> <span data-cy="text_serial_timer_primary_unit">{{lbl.serial.minute}}</span></div>
                </div>
                <div v-else class="text-14 text-a-red-ff4d4d">
                    <div v-if="!this.serialModel.arrangedDate" data-cy="text_serial_code_expired">{{lbl.serial.code_expired}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "SerialTimer",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
        isStaff: Boolean,
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            displayTime: "",
            isTimeExpired: false,
            showTimer: false,
        };
    },
    created: function () {
        this.initial();
    },
    beforeUnmount: function() {
        if (this.timer.interval) {
            this.timer.stopTimer();
        }
    },
    methods: {
        initial: function () {
            if (this.timer.interval) {
                this.timer.stopTimer();
            }

            this.timer.initialTimer(this.serialModel.expireIn, null, true, true);
            if (!this.isStaff) {
                if (this.serialModel.showTimer) {
                    this.showTimer = true;
                    this.isTimeExpired = false;
                    this.timer.runTimer((display) => {
                        this.displayTime = display;
                    }, () => {
                        this.isTimeExpired = true;
                        this.serialExpired();
                    });
                }
            }
        },
        serialExpired: function () {
            this.$emit("onSerialExpired");
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
